var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7811 5.06264C4.7811 4.33407 5.38583 4.05385 6.3874 4.05385C7.82362 4.05385 9.63779 4.48352 11.074 5.24945V0.85934C9.50551 0.242857 7.95591 0 6.3874 0C2.55118 0 0 1.98022 0 5.28681C0 10.4429 7.1811 9.62088 7.1811 11.844C7.1811 12.7033 6.4252 12.9835 5.36693 12.9835C3.79843 12.9835 1.79528 12.3484 0.207874 11.489V15.9352C1.96535 16.6824 3.74173 17 5.36693 17C9.29764 17 12 15.0758 12 11.7319C11.9811 6.16483 4.7811 7.15494 4.7811 5.06264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeBtnIcon);
export default __webpack_public_path__ + "static/media/stripe_btn_icon.9c5db1f0bf85655e179a8dcc079a3fd0.svg";
export { ForwardRef as ReactComponent };